// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"b528fe35","453":"c726cc00"}[chunkId] + ".chunk.js";
};